import React, { Component } from "react";
import { Form, Input, Button, Icon, Checkbox, message, Modal, Row, Col } from "antd";
import Request from "srcDir/util/request";
import config from "projectRoot/config.json";
import Storage from "store2";
import BackImg from "srcDir/assets/images/home_page1.png";
import peiImg from "srcDir/assets/images/peitu.png";
import Logo from "srcDir/assets/images/logo1.png";
import { encryptPassword, validatePassword, createConfirmValidator } from "srcDir/util/passwordValidator";
import "./style.scss";
import { param } from "jquery";

const FormItem = Form.Item;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

// 双因素认证弹窗内部表单
class MfaFormInner extends Component {
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form>
        <FormItem label="验证码" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
          <Row gutter={8}>
            <Col span={16}>
              {getFieldDecorator("code", {
                rules: [
                  { required: true, message: "请输入验证码" },
                  { pattern: /^\d{6}$/, message: "验证码为6位数字" },
                ],
              })(
                <Input placeholder="请输入验证码" maxLength={6} />
              )}
            </Col>
            <Col span={8}>
              <Button
                type="primary"
                disabled={this.props.countdown > 0}
                loading={this.props.sendingCode}
                onClick={this.props.onSendCode}
                style={{ width: "100%" }}
              >
                {this.props.countdown > 0 ? `${this.props.countdown}s后重发` : "获取验证码"}
              </Button>
            </Col>
          </Row>
        </FormItem>
      </Form>
    );
  }
}
const WrappedMfaForm = Form.create()(MfaFormInner);

// 忘记密码弹窗内部表单
class ResetPwdFormInner extends Component {
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form>
        <FormItem label="用户名" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          {getFieldDecorator("username", {
            rules: [{ required: true, message: "请输入用户名" }],
          })(
            <Input placeholder="请输入用户名" />
          )}
        </FormItem>
        <FormItem label="手机号" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          {getFieldDecorator("phone", {
            rules: [
              { required: true, message: "请输入手机号" },
              { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号" },
            ],
          })(
            <Input placeholder="请输入手机号" maxLength={11} />
          )}
        </FormItem>
        <FormItem label="验证码" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          <Row gutter={8}>
            <Col span={14}>
              {getFieldDecorator("code", {
                rules: [
                  { required: true, message: "请输入验证码" },
                  { pattern: /^\d{4,6}$/, message: "验证码为4-6位数字" },
                ],
              })(
                <Input placeholder="请输入验证码" maxLength={6} />
              )}
            </Col>
            <Col span={10}>
              <Button
                type="primary"
                disabled={this.props.countdown > 0}
                loading={this.props.sendingCode}
                onClick={this.props.onSendCode}
                style={{ width: "100%" }}
              >
                {this.props.countdown > 0 ? `${this.props.countdown}s后重发` : "获取验证码"}
              </Button>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="新密码" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          {getFieldDecorator("newPassword", {
            rules: [
              { required: true, message: "请输入新密码" },
              { validator: validatePassword },
            ],
          })(
            <Input type="password" placeholder="请输入新密码" />
          )}
        </FormItem>
        <FormItem label="确认新密码" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          {getFieldDecorator("confirmPassword", {
            rules: [
              { required: true, message: "请确认新密码" },
              { validator: createConfirmValidator(this.props.form, "newPassword") },
            ],
          })(
            <Input type="password" placeholder="请再次输入新密码" />
          )}
        </FormItem>
        <div style={{ color: '#9a9a9aff', fontSize: 12, marginTop: -12, marginBottom: 8, lineHeight: 1.6, textAlign:"center" }}>
          <span style={{ color: '#0985e37c' }}>提示：</span>密码至少8位，需同时包含大写字母、小写字母、数字和特殊符号
        </div>
      </Form>
    );
  }
}
const WrappedResetPwdForm = Form.create()(ResetPwdFormInner);

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logining: false,
      showDoubleFactorModal: false,
      mfaSendingCode: false,
      mfaCountdown: 0,
      mfaVerifying: false,
      mfaUsername: "",
      showResetPwdModal: false,
      resetPwdSendingCode: false,
      resetPwdCountdown: 0,
      resetPwdSubmitting: false,
    };
  }

  componentDidMount() {
    Storage.clear();
    this.props.form.validateFields();
    this.mfaFormRef = React.createRef();
    this.resetPwdFormRef = React.createRef();
  }

  componentWillUnmount() {
    if (this.mfaTimer) {
      clearInterval(this.mfaTimer);
    }
    if (this.resetPwdTimer) {
      clearInterval(this.resetPwdTimer);
    }
  }

  // 双因素认证 - 发送验证码
  handleMfaSendCode = () => {
    const { mfaUsername } = this.state;
    this.setState({ mfaSendingCode: true });
    Request.POST(`${config.host}/mfa`, {
      params:{
        username: mfaUsername,
        method: "send"
      }
    }).then((res) => {
      if (res.success) {
        message.success("验证码已发送");
        this.startMfaCountdown();
      } else {
        message.error(res.msg || "发送验证码失败");
      }
      this.setState({ mfaSendingCode: false });
    }).catch(() => {
      message.error("发送验证码失败，请稍后重试");
      this.setState({ mfaSendingCode: false });
    });
  };

  startMfaCountdown = () => {
    this.setState({ mfaCountdown: 60 });
    this.mfaTimer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.mfaCountdown <= 1) {
          clearInterval(this.mfaTimer);
          return { mfaCountdown: 0 };
        }
        return { mfaCountdown: prevState.mfaCountdown - 1 };
      });
    }, 1000);
  };

  // 双因素认证 - 确定
  handleMfaOk = () => {
    const { current: formRef } = this.mfaFormRef;
    if (!formRef) return;
    const form = formRef.props.form;
    form.validateFields(async (err, values) => {
      if (err) return;
      const { mfaUsername } = this.state;
      this.setState({ mfaVerifying: true });
      try {
        const verifyRes = await Request.POST(`${config.host}/mfa`,
        {
          params:{
            username: mfaUsername,
            code: values.code,
            method: "verify"
          }
        });
        if (!verifyRes.success) {
          message.error(verifyRes.msg || "验证失败");
          this.setState({ mfaVerifying: false });
          return;
        }
        // 验证成功，重新调用登录接口
        this.setState({ showDoubleFactorModal: false, mfaVerifying: false });
        this.props.form.validateFields(async (err2, fields) => {
          if (err2) return;
          this.setState({ logining: true });
          const { password: password, keyId: keyId } = await encryptPassword(fields.password);
          fields.password = password;
          fields.vcode = "code";
          Request.POST(`${config.host}/login?method=platform-username-password-login&keyId=${keyId}`,
            { body: fields },
            false,
            true
          ).then((res) => {
            if (res.success) {
              const token = res.data.token.access_token;
              const tokenBearer = "Bearer " + res.data.token.access_token;
              Storage.set("Authorization", token);
              Storage.set("AuthorizationBearer", tokenBearer);
              window.location.reload();
            } else {
              message.error(res.msg || res.message || "登录失败,请检查网络");
              this.setState({ logining: false });
            }
          });
        });
      } catch (e) {
        message.error("验证失败，请稍后重试");
        this.setState({ mfaVerifying: false });
      }
    });
  };

  handleMfaCancel = () => {
    this.setState({ showDoubleFactorModal: false, mfaCountdown: 0 });
    if (this.mfaTimer) {
      clearInterval(this.mfaTimer);
    }
  };

  // 忘记密码 - 显示弹窗
  handleShowResetPwd = () => {
    this.setState({ showResetPwdModal: true });
  };

  // 忘记密码 - 取消
  handleResetPwdCancel = () => {
    this.setState({ showResetPwdModal: false, resetPwdCountdown: 0 });
    if (this.resetPwdTimer) {
      clearInterval(this.resetPwdTimer);
    }
  };

  // 忘记密码 - 发送验证码
  handleResetPwdSendCode = () => {
    const { current: formRef } = this.resetPwdFormRef;
    if (!formRef) return;
    const form = formRef.props.form;
    form.validateFields(["phone", "username"], async (err, values) => {
      if (err) return;
      this.setState({ resetPwdSendingCode: true });
      try {
        const res = await Request.POST(`${config.host}/login/forgot-password/send-code`, {
          params: {
            phone: values.phone,
            username: values.username,
          },
        });
        if (res.success) {
          message.success("验证码已发送");
          this.startResetPwdCountdown();
        } else {
          message.error(res.msg || "发送验证码失败");
        }
      } catch (e) {
        message.error("发送验证码失败，请稍后重试");
      }
      this.setState({ resetPwdSendingCode: false });
    });
  };

  startResetPwdCountdown = () => {
    this.setState({ resetPwdCountdown: 60 });
    this.resetPwdTimer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.resetPwdCountdown <= 1) {
          clearInterval(this.resetPwdTimer);
          return { resetPwdCountdown: 0 };
        }
        return { resetPwdCountdown: prevState.resetPwdCountdown - 1 };
      });
    }, 1000);
  };

  // 忘记密码 - 确定提交
  handleResetPwdOk = () => {
    const { current: formRef } = this.resetPwdFormRef;
    if (!formRef) return;
    const form = formRef.props.form;
    form.validateFields(async (err, values) => {
      if (err) return;
      this.setState({ resetPwdSubmitting: true });
      try {
        // const { password: encryptedPwd } = await encryptPassword(values.newPassword);
        const encryptedPwd = values.newPassword;
        const res = await Request.POST(`${config.host}/login/forgot-password/reset`, {
          body: {
            username: values.username,
            phone: values.phone,
            validateCode: values.code,
            newPassword: encryptedPwd,
          },
        });
        if (res.success) {
          message.success("密码重置成功，请使用新密码登录");
          this.handleResetPwdCancel();
          form.resetFields();
        } else {
          message.error(res.msg || "密码重置失败");
        }
      } catch (e) {
        message.error("密码重置失败，请稍后重试");
      }
      this.setState({ resetPwdSubmitting: false });
    });
  };

  async getEncryptKey() {
    
    const res = await Request.GET(`${config.host}/encrypt-key/get`);
    if (res.success && res.data) {
      const { key, keyId, expiresIn } = res.data;
      const expiresAt = Date.now() + (parseInt(expiresIn, 10) || 300) * 1000;
      Storage.set('sm4_encrypt_key', { key, keyId, expiresAt });
      return { key, keyId };
    }
    return { key: null, keyId: null };
  }

  normalizeKeyForSmCrypto(rawKey) {
    // 1. 使用 UTF-8 编码将原始字符串转换为字节数组
    const encoder = new TextEncoder();
    const rawKeyBytes = encoder.encode(rawKey);
    
    // 2. 创建一个长度为 16 的字节数组，并用 0 填充（模拟 Java 补 \0）
    const finalKey = new Uint8Array(16);
    
    // 3. 将原始密钥的字节放入新数组，如果长度不足 16，末尾会自动补 0
    const copyLength = Math.min(rawKeyBytes.length, 16);
    finalKey.set(rawKeyBytes.slice(0, copyLength));
    
    return finalKey;
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFields(async (err, fields) => {
      if (!err) {
        this.setState({ logining: true });
        fields.vcode = "code";
        // 使用 SM4 算法加密密码
        const { password: password, keyId: keyId } = await encryptPassword(fields.password);
        fields.password = password;
        Request.POST(`${config.host}/login?method=platform-username-password-login&keyId=${keyId}`,
        // Request.POST(`${config.host}/login?method=platform-username-password-login`,
          {
            body: fields,
          },
          false,
          true
        ).then((res) => {
          if (res.success) {
            const token = res.data.token.access_token;
            const tokenBearer = "Bearer " + res.data.token.access_token;
            Storage.set("Authorization", token);
            Storage.set("AuthorizationBearer", tokenBearer);
            window.location.reload();
          } else {
            message.error(res.msg || res.message || "登录失败,请检查网络");
            this.setState({ logining: false });
            if (res.msg == "请先完成双因素认证"){
              //需要双因素认证
              this.setState({ showDoubleFactorModal: true, mfaUsername: fields.username });
            }
          }
        });
      }
    });
  }

  render() {
    const { getFieldDecorator, isFieldTouched, getFieldError, getFieldsError } =
      this.props.form;
    const { logining, showDoubleFactorModal, mfaSendingCode, mfaCountdown, mfaVerifying, mfaUsername, showResetPwdModal, resetPwdSendingCode, resetPwdCountdown, resetPwdSubmitting } = this.state;

    const userNameError =
      isFieldTouched("userName") && getFieldError("userName");
    const passwordError =
      isFieldTouched("password") && getFieldError("password");
    return (
      <div
        style={{
          background: `url(${BackImg})`,
          backgroundSize: "100% 100%",
          position: "relative",
        }}
        className="login-wrap"
      >
        <div
          style={{
            position: "absolute",
            left: "15%",
            top: "15%",
            width: "70%",
            height: "70%",
            display:"flex",
          }}
        >
          <div
            style={{
              background: `url(${peiImg}) repeat center center`,
              width:"60%",
              backgroundSize: "100% 100%",
            }}
          />
          <div
            className="login-box"
            style={{
              width: "30%",
              marginLeft:"5%",
              marginTop:"5%"
            }}
          >
            <img src={Logo} alt="" />
            <Form onSubmit={(e) => this.handleSubmit(e)}>
              <FormItem
                validateStatus={userNameError ? "error" : ""}
                help={userNameError || ""}
              >
                {getFieldDecorator("username", {
                  rules: [{ required: true, message: "请输入账号!" }],
                })(
                  <Input
                    prefix={
                      <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                    placeholder="用户名/邮箱/手机号码"
                  />
                )}
              </FormItem>
              <FormItem
                validateStatus={passwordError ? "error" : ""}
                help={passwordError || ""}
              >
                {getFieldDecorator("password", {
                  rules: [{ required: true, message: "请输入密码!" }],
                })(
                  <Input
                    prefix={
                      <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                    type="password"
                    placeholder="密码"
                  />
                )}
              </FormItem>
              <FormItem>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                  <div>
                    {getFieldDecorator("remember", {
                      valuePropName: "checked",
                      initialValue: false,
                    })(<Checkbox style={{color: '#FFFFFF'}}>记住我</Checkbox>)}
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-btn"
                      loading={logining}
                      disabled={hasErrors(getFieldsError())}
                    >
                      登录
                    </Button>
                  </div>
                  <div
                    style={{
                      color: '#d5d5d5ff',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      userSelect: 'none',
                    }}
                    onClick={this.handleShowResetPwd}
                  >
                    忘记密码
                  </div>
                </div>
              </FormItem>
            </Form>
          </div>
        </div>
        <Modal
          title="双因素认证"
          visible={showDoubleFactorModal}
          okText="验证"
          cancelText="取消"
          onOk={this.handleMfaOk}
          onCancel={this.handleMfaCancel}
          confirmLoading={mfaVerifying}
          closable={false}
          maskClosable={false}
          width={460}
        >
          <div style={{ marginBottom: 16, color: "#636e72", lineHeight: 1.8 }}>
            <p>当前账号：<strong>{mfaUsername}</strong></p>
            <p>请完成双因素认证以继续登录。</p>
          </div>
          <WrappedMfaForm
            wrappedComponentRef={(inst) => {
              this.mfaFormRef.current = inst;
            }}
            sendingCode={mfaSendingCode}
            countdown={mfaCountdown}
            onSendCode={this.handleMfaSendCode}
          />
        </Modal>
        <Modal
          title="重置密码"
          visible={showResetPwdModal}
          okText="确认重置"
          cancelText="取消"
          onOk={this.handleResetPwdOk}
          onCancel={this.handleResetPwdCancel}
          confirmLoading={resetPwdSubmitting}
          closable={false}
          maskClosable={false}
          width={480}
        >
          <WrappedResetPwdForm
            wrappedComponentRef={(inst) => {
              this.resetPwdFormRef.current = inst;
            }}
            sendingCode={resetPwdSendingCode}
            countdown={resetPwdCountdown}
            onSendCode={this.handleResetPwdSendCode}
          />
        </Modal>
      </div>
    );
  }
}

export default Form.create()(index);



// WEBPACK FOOTER //
// ./src/components/Login/index.js